export const HOSTNAME = window.location.hostname === 'localhost' ? 'test.inspire.direct' : window.location.hostname
